export const InputProperty = {
  Name: 'name',
  Value: 'value',
  Disabled: 'disabled',
  Placeholder: 'placeholder',
  Label: 'label',
  Type: 'type',
  IsReadonly: 'isReadonly',
  AreaLabel: 'areaLabel',
  MaxLength: 'maxLength',
  MinLength: 'minLength',
  MaxNumber: 'maxNumber',
  MinNumber: 'minNumber',
  Step: 'step',
  FillType: 'fillType',
  ColorScheme: 'colorScheme',
  IsLoading: 'isLoading',
};

export const InputFillType = {
  Outlined: 'outlined',
  Dashed: 'dashed',
  Underlined: 'underlined',
};

export const InputType = {
  Text: 'text',
  Password: 'password',
  Email: 'email',
  Number: 'number',
  Telephone: 'tel',
};

export const InputEventType = {
  Focus: 'focus',
  Change: 'change',
  Input: 'input',
  Blur: 'blur',
};

export const InputSlotType = {
  Append: 'append',
  Prepend: 'prepend',
};

export default {
  InputProperty,
};
